import React from 'react'
import { connect } from 'react-redux'

import { notifyError, completeCheckoutAsync } from '../actions'

import { mapStateToPlaceOrderDetails } from './mapStateToPlaceOrderDetails'

import CheckoutComplete from './CheckoutComplete'


const mapCheckoutCompleteStateToProps = (state, ownProps) => {
  var placeOrderDetails = mapStateToPlaceOrderDetails(state);
  placeOrderDetails.constants = state.constants; // Hack on the constants object so we can see what constant values are when we validate
  return {
    buttonText: state.ui.completeCheckoutButtonText,
    placeOrderDetails: placeOrderDetails,
    isPlaceOrderPending: state.ui.isPlaceOrderPending,
    ...ownProps
  }
}

const SelectedBillingAddressCanBeSumbitted = (address) => {
  return (
      // If truthy, then return the message at the end, otherwise return falsy
      (!address ||
        !address.Id // True if address.Id is falsy
        ||
        !(
          !!address.Name &&
            !!address.AddressLine1 &&
            !!address.City &&
            !!address.State &&
            !!address.CountryCode &&
        !!address.PostalCode))
    && 'Please select your billing address, or fix the billing address to include all required fields'
  )
}

const paymentIsInvalid = (constants, { Id, POValue, BraintreePaymentNonce }) => {
  if (!Id) {
    return 'Please select and complete a payment';
  } else if (Id === constants.braintreeSettings.braintreePaymentId && !BraintreePaymentNonce) {
    return 'Please complete Braintree checkout or select a different payment method';
  }
  return false;
}

// BBS DDD 2017-12-01 This archaic validation could probably be 
// replaced. see mapTopLevelPPropsToInitialStore.js for suggestion of valdatejs.org or such
const orderDetailsCanBeSubmitted = (orderDetails) => {
  const keys = Object.keys(orderDetails);
  return keys
    .map(key => { // look through the keys of order details
      const value = orderDetails[key];
      // for each key, validate that we have an
      // object we can submit

      switch (key) {        
        
        // If our validation fails and we get a true
        // value for the condition, then return a message
        // for this key
        case 'SelectedShippingAddress':                              
          return false; // BBS DDD 2018-01-18 No shipping address necessary

        case 'SelectedBillingAddress':
          return SelectedBillingAddressCanBeSumbitted(value);

        case 'SelectedShippingOption':
          return false;  // BBS DDD 2018-01-18 No shipping option necessary

        // We want an object with an Id and either a POValue or a BraintreePaymentNonce
        case 'SelectedPayment':
          return paymentIsInvalid(orderDetails.constants, value);

        case 'BillingEqualsShipping':
          return (typeof BillingEqualsShipping === 'boolean');

        // We just stick constants on our place order details object so we can see them
        case 'constants':
          return false;

        // Unknown properties in orderDetails => validation failure
        default:                                           
          return `Unkown order detail: '${key}'`;
      }
    })
    .filter(x => !!x);
    // Only return something truthy, which should only be non-empty strings
    // whose value is a message giving a reason why validation failed

}

const mapCheckoutCompleteDispatchToProps = (dispatch) => {
  return {
    onCompleteCheckout: (placeOrderDetails) => {
      const errors = orderDetailsCanBeSubmitted(placeOrderDetails);
      if (errors.length === 0) {
        delete placeOrderDetails.constants; // Remove the property we stuck on to share state above in mapCheckoutCompleteStateToProps
        dispatch(completeCheckoutAsync(placeOrderDetails));
      } else {
        const intro = "Sorry, but we can't submit your order yet: ";
        const message = errors.reduce((acc, cur) => acc + '\n' + cur, intro);
        dispatch(notifyError(message));
      }
    }
  }
}

const CheckoutCompleteContainer = connect(mapCheckoutCompleteStateToProps, mapCheckoutCompleteDispatchToProps)(CheckoutComplete)

export default CheckoutCompleteContainer